import React, { useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { AuthContext } from '../navigation/AuthProvider';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import toast, { Toaster } from 'react-hot-toast';
import styled from 'styled-components';
import { useToast } from '../controller/ToastController';

export const LoginContract = (oProps: any) => {
  const showToast = useToast();
  const canvasImg = useRef<SignatureCanvas | null>(null);

  const CanvasWrapper = styled.div`
    position: relative;
  `;
  const CanvasPlaceholder = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #999;
    font-weight: 400;
  `;

  const handleConfirm = () => {
    if (canvasImg.current) {
      const isSignatureEmpty = canvasImg.current.isEmpty();

      if (isSignatureEmpty) {
        showToast('약관 동의 서명을 해주세요.', 'error');
      } else {
        console.log('suceess->>>>>서명이 있습니다.');
      }
    }
  };

  return (
    <Style>
      <div className="wrap">
        <div className="container">
          <img
            className="logo"
            src={`${process.env.PUBLIC_URL}/svg/ic_logo_black.svg`}
            alt="logo"
            width="100%"
            style={{
              maxWidth: '44px',
            }}
          />
          <h1>전자서명</h1>
          <h2>
            전자서명 문서 내용을 모두 확인 후,
            <br /> 전자서명을 진행해주세요.
          </h2>

          <div className="title">
            <h2>전자서명 문서 목록</h2>
          </div>
          <div className="pdfList">
            <ul>
              <li>
                <img
                  className="logo"
                  src={`${process.env.PUBLIC_URL}/img/pdfImage.png`}
                  alt="logo"
                  width="100%"
                  style={{
                    maxWidth: '14px',
                  }}
                />
                <h2>전자거래금융이용약관</h2>
                <a
                  target="_blank"
                  href="https://stg-ss-storage.s3.ap-northeast-2.amazonaws.com/%ec%95%bd%ea%b4%80%ed%85%8c%ec%8a%a4%ed%8a%b8/%eb%b9%84%ed%95%98%ec%9d%b8%eb%93%9c+%ea%b0%9c%ec%9d%b8%ec%a0%95%eb%b3%b4%ec%b2%98%eb%a6%ac%eb%b0%a9%ec%b9%a8.pdf">
                  보기
                </a>
              </li>
              <li>
                <img
                  className="logo"
                  src={`${process.env.PUBLIC_URL}/img/pdfImage.png`}
                  alt="logo"
                  width="100%"
                  style={{
                    maxWidth: '14px',
                  }}
                />
                <h2>판매자 개인정보 수집 및 이용 동의</h2>
                <a
                  target="_blank"
                  href="https://stg-ss-storage.s3.ap-northeast-2.amazonaws.com/%ec%95%bd%ea%b4%80%ed%85%8c%ec%8a%a4%ed%8a%b8/%eb%b9%84%ed%95%98%ec%9d%b8%eb%93%9c+%ea%b0%9c%ec%9d%b8%ec%a0%95%eb%b3%b4%ec%b2%98%eb%a6%ac%eb%b0%a9%ec%b9%a8.pdf">
                  보기
                </a>
              </li>
              <li>
                <img
                  className="logo"
                  src={`${process.env.PUBLIC_URL}/img/pdfImage.png`}
                  alt="logo"
                  width="100%"
                  style={{
                    maxWidth: '14px',
                  }}
                />
                <h2>판매자 이용 약관</h2>
                <a
                  target="_blank"
                  href="https://stg-ss-storage.s3.ap-northeast-2.amazonaws.com/%ec%95%bd%ea%b4%80%ed%85%8c%ec%8a%a4%ed%8a%b8/%eb%b9%84%ed%95%98%ec%9d%b8%eb%93%9c+%ea%b0%9c%ec%9d%b8%ec%a0%95%eb%b3%b4%ec%b2%98%eb%a6%ac%eb%b0%a9%ec%b9%a8.pdf">
                  보기
                </a>
              </li>
            </ul>
          </div>
          <div className="title">
            <h2>약관동의 서명란</h2>
          </div>
          <div className="canvasBox">
            <CanvasWrapper>
              <CanvasPlaceholder>여기에 서명을 해주세요.</CanvasPlaceholder>
              <SignatureCanvas
                ref={canvasImg}
                clearOnResize={false}
                canvasProps={{ className: 'sigCanvas' }}
              />
            </CanvasWrapper>
          </div>
          <button onClick={handleConfirm} className="successButton">
            확인
          </button>
        </div>
      </div>
      <Toaster />
    </Style>
  );
};

export const Style = styled.div`
  .wrap {
    width: 100%;
    height: 100%;
    background: #f8fafc;
  }
  .container {
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    min-height: 100vh;
    padding: 20px 4vw !important;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  ul,
  li,
  a {
    list-style: none;
  }
  h1 {
    margin: 24px 0 12px 0;
    font-size: 26px;
    font-weight: 700;
    color: #26282c;
  }
  h2 {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    color: #555555;
  }

  /* title */
  .title {
    width: 100%;
    margin: 20px 0 0px 0;
    padding: 8px 16px;
    border-radius: 5px;
    background: #ecf5f3;

    h2 {
      font-size: 16px;
    }
  }

  /* pdfList */
  .pdfList {
    width: 100%;
    ul {
      padding: 0;
    }
    li {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 8px;
      border-radius: 5px;
      border: 1px solid #4dd2ae;

      h2 {
        margin-left: 6px;
        font-size: 14px;
        font-weight: 400;
      }
      a {
        margin-left: auto;
        margin-right: 4px;
        color: #40977f;
        font-size: 14px;
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }

  /* canvasBox */
  .canvasBox {
    width: 100%;
    margin-top: 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
  }
  .sigCanvas {
    width: 100%;
    height: 170px;
  }

  /* successButton */
  .successButton {
    width: 100%;
    margin: 32px 0 12px 0;
    padding: 12px 0;
    background: #4dd2ae;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    border-radius: 5px;
  }
`;
